export const crmEntityType = entity => entity.type === 'bank' ? 'institution' : entity.type;
export const entityNoun = entity => ({ bank: 'банка', country: 'страны', email: 'email' })[entity.type];
export function isOverviewEntity(entity) {
  if (!entity || typeof entity.value !== 'string' || !entity.value.trim() || entity.value.length > 256 || typeof entity.label !== 'string' || !entity.label.trim()) return false;
  if (entity.type === 'bank') return !/[\u0000-\u001f\u007f]|\S+@\S+|https?:\/\/|\d{8,}/i.test(entity.value);
  if (entity.type === 'country') return /^[A-Z]{2}$/.test(entity.value) && !['XX', 'ZZ'].includes(entity.value);
  return entity.type === 'email' && /^[^\s@<>]+@[^\s@<>]+\.[^\s@<>]+$/.test(entity.value) && entity.value.length <= 254;
}
export function countryEntity(value) {
  const code = typeof value === 'string' ? value.trim().toUpperCase() : '';
  const entity = { type: 'country', value: code, label: code };
  if (!isOverviewEntity(entity)) return undefined;
  try { entity.label = new Intl.DisplayNames(['ru'], { type: 'region', fallback: 'none' }).of(code === 'UK' ? 'GB' : code); } catch { return undefined; }
  return entity.label ? entity : undefined;
}
